import { Component, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { RespSignin } from "../model/auth.model";
import { AuthService } from "../service/auth.service";

@Component({
  selector: "app-auth-sig-in",
  templateUrl: "./auth-sig-in.component.html",
  styleUrls: ["./auth-sig-in.component.css"],
})
export class AuthSigInComponent implements OnInit {
  username = new FormControl("", [Validators.required]);
  password = new FormControl("", [Validators.required]);
  remember = true;

  constructor(private authService: AuthService, private router: Router) { }

  signinObs$!: Observable<any>;
  hide = true;
  ngOnInit(): void { }

  signIn() {
    this.authService
      .signin({
        username: this.username.value,
        password: this.password.value,
      })
      .subscribe((_response: RespSignin) => {
        if (_response.success) {
          this.router.navigate(["/inicio"]);
        }
      });
  }

  goSignUp() {
    this.router.navigate(["/sign-up"]);
  }

  forgotPassword() { }
}
